import React from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
} from '@mui/material';
import { useUnlayerUIContext } from '@/context/UnlayerUIContext';
import { useUnlayerComposeInteractionsContext } from '@/context/UnlayerComposeInteractionsContext';

/**
 * Allows a raw Unlayer design JSON payload to be loaded into the current editor session.
 * Used by template management views with explicit state, and by the compose drawer via props
 * wired from UnlayerUIContext / UnlayerComposeInteractionsContext.
 */
export const LoadDesignJsonDialog = ({
	loadDesignJsonError = '',
	loadDesignJsonValue = '',
	onClose,
	onLoad,
	onValueChange,
	open = false,
}) => {
	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
			<DialogTitle>Load Design JSON</DialogTitle>
			<DialogContent>
				<TextField
					fullWidth
					multiline
					minRows={10}
					label='Full Unlayer design json'
					value={loadDesignJsonValue}
					onChange={(event) => onValueChange(event.target.value)}
					error={Boolean(loadDesignJsonError)}
					helperText={loadDesignJsonError || ' '}
					sx={{ mt: 1 }}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button variant='contained' onClick={onLoad}>
					Load
				</Button>
			</DialogActions>
		</Dialog>
	);
};
